import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError (error: Error): Partial<State> {
    return { hasError: true, error }
  }

  componentDidCatch (error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo })
    console.error('ErrorBoundary:', error, errorInfo)
  }

  render () {
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{ padding: 24, margin: 24, backgroundColor: '#fff', border: '2px solid #c53030', borderRadius: 8, color: '#1a1a1a', fontFamily: 'system-ui, sans-serif' }}>
          <h2 style={{ margin: '0 0 12px 0', color: '#c53030' }}>Something went wrong</h2>
          <pre style={{ margin: 0, padding: 12, background: '#f8f6f3', borderRadius: 6, overflow: 'auto', fontSize: 13 }}>
            {this.state.error.toString()}
            {this.state.errorInfo?.componentStack && (
              <span style={{ display: 'block', marginTop: 12, whiteSpace: 'pre-wrap' }}>{this.state.errorInfo.componentStack}</span>
            )}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}
